import {
  BACKGROUND_OPERATION_ENDPOINTS_LOWERCASE,
  ENDPOINTS_EXCLUDED_FROM_LOADING_LOWERCASE,
} from './endpoints'

export const shouldShowLoadingIndicator = (currentUrlPath: string, requestUrlPath?: string) => {
  if (!requestUrlPath) return true

  const lowercaseCurrentUrlPath = currentUrlPath.toLowerCase()
  const lowercaseRequestUrlPath = requestUrlPath.toLowerCase()

  // Check if the request is for a background operation
  const backgroundOperations = BACKGROUND_OPERATION_ENDPOINTS_LOWERCASE[lowercaseCurrentUrlPath]
  if (backgroundOperations)
    return !backgroundOperations.skipLoadingIndicators.has(lowercaseRequestUrlPath)

  // Check if the request is excluded from loading
  return !ENDPOINTS_EXCLUDED_FROM_LOADING_LOWERCASE.has(lowercaseRequestUrlPath)
}
